import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import EngagingMenuPageStyle from './engaging-menu-page.module.scss';

const HeroContent = () => (
  <StaticQuery
    query={graphql`
      query EngagingMenuHero {
        contentfulEngagingMenuPage {
          engagingMenuReference {
            hero {
              headline {
                headline
              }
              paragraph {
                json
              }
            }
          }
        }
      }
    `}
    render={(data) => (
      <div className={EngagingMenuPageStyle.heroContentDiv}>
        <h1 className={EngagingMenuPageStyle.heroTitle}>
          {
            data.contentfulEngagingMenuPage.engagingMenuReference.hero.headline
              .headline
          }
        </h1>
        <div className={EngagingMenuPageStyle.heroDescription}>
          {documentToReactComponents(
            data.contentfulEngagingMenuPage.engagingMenuReference.hero.paragraph
              .json
          )}
        </div>
        <a
          href='https://app.firststringdigital.com/starter-monthly'
          className='hero-btn'
        >
          Start My Free Trial
        </a>
      </div>
    )}
  />
);

export default HeroContent;
